import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14c52cb2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pause-screen__content" }
const _hoisted_2 = { class: "pause-screen__text" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{ 'pause-screen--show': _ctx.paused }, "pause-screen"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, [
        _createTextVNode(_toDisplayString(_ctx.opponent.pseudo) + " est déconnecté !", 1),
        _hoisted_3,
        _createTextVNode("Fin de la partie dans " + _toDisplayString(this.minutes) + "min" + _toDisplayString(this.formatedSeconds) + "s ", 1)
      ])
    ])
  ], 2))
}